module.exports = __webpack_public_path__ + "img/qfpay.f23cc2b4.jpg";